export const tilesApiUrl = "/home/api";

export const cpApiUrl = "/cp/api";
